import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// DSN is a public identifier meant to be embedded client-side (same category
// as the Supabase anon key and Razorpay Key ID already hardcoded elsewhere in
// this app) — it only lets this app send error events, not read any data.
Sentry.init({
  dsn: 'https://4e460d2cb01a0686a49067b0b5459654@o4511681932754944.ingest.us.sentry.io/4511681945337856',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
